import { Alert, Button, Card, Col, Row } from 'react-bootstrap';
import { ProgressBarCampaign } from './shared/ProgressBarCampaign';
import { CampaignOverviewCard } from './shared/CampaignOverviewCard';
import React, { ChangeEvent, useEffect, useState } from 'react';
import Tab from '@mui/material/Tab';
import Counter from '../../../../../shared/components/Counter';
import { StepperRouting } from './shared/StepperRouting';
import { InfoBox } from '../../../../../shared/components/alert/InfoBox';
import { BriefingService } from '../service';
import { useNavigate, useParams } from 'react-router-dom';
import { ErrorToast, SuccessToast } from '../../../../../utils/toasters';
import { Platforms } from '../../../../../model/platform/Platforms';
import { useTranslation } from 'react-i18next';
import { IParams } from '../../../../../model/shared/IParams';
import { oneStepUp } from '../../../../../shared/functions/Functions';
import { TabPanel } from '@mui/lab';
import TabList from '@mui/lab/TabList';
import Box from '@mui/material/Box';
import TabContext from '@mui/lab/TabContext';
import CardLayout from '../../../../../shared/components/card/CardLayout';

const tabs = ['recommended']; // removed 'Short Term', 'Long Term' for now => IV-1396

export const StepFour = () => {
    const navigate = useNavigate();
    const [value, setValue] = useState('0');
    const [status, setStatus] = useState('');
    const [platforms, setPlatforms] = useState<Platforms[]>([]);
    const [selectedPlatforms, setSelectedPlatforms] = useState<Platforms[]>([]);
    const [isBriefingComplete, setIsBriefingComplete] = useState(true);
    const [isNextClicked, setIsNextClicked] = useState(false);

    const { t } = useTranslation();
    const { id } = useParams<keyof IParams>();

    useEffect(() => {
        BriefingService.getBriefingStepFourth(id)
            .then(response => {
                const filteredPlatforms = response.filteredPlatforms.data;
                setPlatforms(response.filteredPlatforms.data);
                setStatus(response?.status);
                setIsBriefingComplete(response?.isBriefingComplete);
                const selectedArr: Platforms[] = [];
                filteredPlatforms?.map(platform =>
                    platform?.platformItems?.map(item => item.isSelected && selectedArr.push(item))
                );
                setSelectedPlatforms(selectedArr);
            })
            .catch(err => ErrorToast(err));
    }, []);

    const updateStepFourth = () => {
        if (!selectedPlatforms?.length) {
            return;
        }
        setIsNextClicked(true);
        BriefingService.updateBriefingByStep(id ?? '', { platforms: selectedPlatforms }, 'fourth')
            .then(response => {
                if (response) {
                    oneStepUp(navigate, id ?? '', response.isBriefingComplete, response.briefingStep);
                    SuccessToast(`${t('general.alert.success_updated_campaign_step')}`);
                }
            })
            .catch(error => ErrorToast(error))
            .finally(() => {
                setIsNextClicked(false);
            });
    };

    function changeHandlerPlatforms(
        key: number,
        event?: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        nbPosts?: number,
        itemId?: number
    ) {
        const selectedArr: Platforms[] = [];
        const allIPlatforms = [...platforms];
        const findPlatform = allIPlatforms.find(item => item.id === key);
        const findPlatformItem = findPlatform?.platformItems.find(item => item.id === itemId);
        if (findPlatformItem) {
            findPlatformItem.nbPosts = nbPosts;
        }
        allIPlatforms.map(platform =>
            platform.platformItems.filter(item => (item.nbPosts ?? 0 > 0) && selectedArr.push(item))
        );
        setPlatforms(allIPlatforms);
        setSelectedPlatforms(selectedArr);
    }

    const handleTabs = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    return (
        <Row className="mb-5 pb-5">
            <Col md={8}>
                {!isBriefingComplete ? (
                    <div className="mb-4">
                        <ProgressBarCampaign
                            title={t('brand.campaign.briefing.step4.platforms_and_placements')}
                            percent={30}
                        />
                    </div>
                ) : null}
                <div>
                    <h5 className="font-weight-bold">{t('brand.campaign.briefing.step4.which_content')}</h5>
                </div>
                <div className="my-3">
                    <span className="font-weight-bold">{t('brand.campaign.briefing.step4.placements')}</span>
                    <span className="text-muted">
                        {' '}
                        {t('brand.campaign.briefing.step4.which_content_per_influencer')}
                        <span className="text-info"> {t('brand.campaign.briefing.step4.recommended_purple')}</span>
                    </span>
                </div>

                <Card>
                    <Card.Body id="campaign-tabpanel">
                        <div
                            className={`d-flex align-items-center justify-content-${
                                !selectedPlatforms?.length ? 'between' : 'end'
                            }`}
                        >
                            {!selectedPlatforms?.length && (
                                <div className="d-flex">
                                    <Alert variant="danger">
                                        {t('brand.campaign.briefing.step4.platformsNotSelected')}
                                    </Alert>
                                </div>
                            )}
                            <Button variant="primary" onClick={() => navigate(`/brand/create/campaign/${id}/step1`)}>
                                {t('brand.campaign.briefing.step4.morePlatforms')}
                            </Button>
                        </div>

                        <TabContext value={value}>
                            <Box className="mb-3">
                                <TabList onChange={handleTabs}>
                                    {tabs?.map((tab, index) => {
                                        return (
                                            <Tab
                                                key={tab}
                                                label={t(`brand.campaign.briefing.step4.${tab}`)}
                                                value={String(index)}
                                            />
                                        );
                                    })}
                                </TabList>
                            </Box>
                            <TabPanel value="0" key="campaign-tabpanel">
                                <Row>
                                    {platforms?.map(platform => (
                                        <Col className="mb-3" key={platform?.id} md={6}>
                                            <div className="d-flex align-items-center">
                                                <img src={platform?.path} width={30} alt={platform?.icon} />
                                                <h5 className="mb-0 ml-2 font-weight-semi-bold">{platform.name}</h5>
                                            </div>
                                            <div className="pl-4 mt-2">
                                                {platform?.platformItems?.map(item => (
                                                    <div
                                                        className="d-flex align-items-center justify-content-between my-2"
                                                        key={item.id}
                                                    >
                                                        <div className="d-flex align-items-center">
                                                            <img src={item.path} width={30} alt={item.icon} />
                                                            <span className="mb-0 ml-2">
                                                                {t(`general.platforms.${item.name}`)}
                                                            </span>
                                                        </div>
                                                        <Counter
                                                            id={platform.id}
                                                            defaultCount={item.nbPosts ?? 0}
                                                            setNumberItems={changeHandlerPlatforms}
                                                            itemId={item?.id}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </TabPanel>
                            <TabPanel value="1">
                                <Row>
                                    {platforms?.map(platform => (
                                        <Col className="mb-3" key={platform?.id} md={6}>
                                            <div className="d-flex align-items-center">
                                                <img src={platform?.path} width={30} alt={platform?.icon} />
                                                <h5 className="mb-0 ml-2 font-weight-bold">
                                                    {t(`general.platforms.${platform.name}`)}
                                                </h5>
                                            </div>
                                            <div className="pl-4 mt-2">
                                                {platform.platformItems.map(
                                                    item =>
                                                        !item.isLongTerm && (
                                                            <div
                                                                className="d-flex align-items-center justify-content-between my-2"
                                                                key={item.id}
                                                            >
                                                                <div className="d-flex align-items-center">
                                                                    <img src={item.path} width={30} alt={item.icon} />
                                                                    <span className="mb-0 ml-2">
                                                                        {t(`general.platforms.${item.name}`)}
                                                                    </span>
                                                                </div>
                                                                <Counter
                                                                    id={platform.id}
                                                                    defaultCount={item.nbPosts ?? 0}
                                                                    setNumberItems={changeHandlerPlatforms}
                                                                    itemId={item?.id}
                                                                />
                                                            </div>
                                                        )
                                                )}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </TabPanel>
                            <TabPanel value="2">
                                <Row>
                                    {platforms?.map(platform => (
                                        <Col className="mb-3" key={platform?.id} md={6}>
                                            <div className="d-flex align-items-center">
                                                <img src={platform?.path} width={30} alt={platform?.icon} />
                                                <h5 className="mb-0 ml-2 font-weight-bold">
                                                    {t(`general.platforms.${platform.name}`)}
                                                </h5>
                                            </div>
                                            <div className="pl-4 mt-2">
                                                {platform.platformItems.map(
                                                    item =>
                                                        item.isLongTerm && (
                                                            <div
                                                                className="d-flex align-items-center justify-content-between my-2"
                                                                key={item.id}
                                                            >
                                                                <div className="d-flex align-items-center">
                                                                    <img src={item.path} width={30} alt={item.icon} />
                                                                    <span className="mb-0 ml-2">
                                                                        {t(`general.platforms.${item.name}`)}
                                                                    </span>
                                                                </div>
                                                                <Counter
                                                                    id={platform.id}
                                                                    defaultCount={item.nbPosts ?? 0}
                                                                    setNumberItems={changeHandlerPlatforms}
                                                                    itemId={item?.id}
                                                                />
                                                            </div>
                                                        )
                                                )}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </TabPanel>
                        </TabContext>
                    </Card.Body>
                </Card>
                <CardLayout classCard="mt-4">
                    <h5 className="font-weight-bold">
                        {t('brand.campaign.briefing.step4.summary_postings_per_influencer')}
                    </h5>
                    <div className="d-flex align-items-center flex-column flex-md-row">
                        <div className="w-md-75">
                            {selectedPlatforms?.map(item => (
                                <Row key={item.id} className="align-items-center my-2">
                                    <Col md={6} xs={9} className="d-flex align-items-center">
                                        <img src={item.path} width={30} alt={item.name} />
                                        <span className="mb-0 ml-2">{t(`general.platforms.${item.name}`)}</span>
                                    </Col>
                                    <Col md={6} xs={3}>
                                        <span className="text-primary font-weight-semi-bold mb-0 ml-3">
                                            x{item.nbPosts}
                                        </span>
                                    </Col>
                                </Row>
                            ))}
                        </div>
                        <div className="w-md-25">
                            <InfoBox
                                variant="info"
                                title="influence.vision Feedback"
                                text={t('brand.campaign.briefing.step4.iv_feedback')}
                                buttonName=""
                            />
                        </div>
                    </div>
                    <StepperRouting
                        submitStepHandler={updateStepFourth}
                        isNextDisabled={isNextClicked}
                        status={status}
                    />
                </CardLayout>
            </Col>
            <Col md={4} className="pr-md-4">
                <CampaignOverviewCard />
            </Col>
        </Row>
    );
};
